/* eslint-disable */
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  showHeightBio: ['data'],
 
})

export const ReadMoreTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  height: 130,

})

/* ------------- Selectors ------------- */

export const ReadMoreSelectors = {
  getData: state => state.data
}

/* ------------- Reducers ------------- */


export const showHeightBio = (state, action) => {
  const { data } = action
  
  return state.merge({ fetching: false, error: null, height : data.height })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {

  [Types.SHOW_HEIGHT_BIO]: showHeightBio,

})
